var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAscIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 6,
    viewBox: "0 0 7 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84025 5.61796C2.80642 5.585 2.66175 5.46055 2.54275 5.34462C1.79433 4.66496 0.569333 2.89195 0.195417 1.96396C0.135333 1.82302 0.00816667 1.46672 0 1.27634C0 1.09393 0.042 0.920036 0.127167 0.7541C0.246167 0.547248 0.433417 0.381312 0.6545 0.290388C0.807917 0.231856 1.267 0.140932 1.27517 0.140932C1.77742 0.0500081 2.5935 0 3.49533 0C4.35458 0 5.13742 0.0500081 5.64725 0.124452C5.65542 0.132976 6.22592 0.2239 6.42133 0.323348C6.77833 0.505764 7 0.862072 7 1.24338V1.27634C6.99125 1.52468 6.76958 2.04692 6.76142 2.04692C6.38692 2.92491 5.222 4.65701 4.44792 5.35314C4.44792 5.35314 4.249 5.5492 4.12475 5.63444C3.94625 5.76741 3.72517 5.83333 3.50408 5.83333C3.25733 5.83333 3.0275 5.75889 2.84025 5.61796Z",
    fill: "#7E818D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAscIcon);
export default __webpack_public_path__ + "static/media/ascIcon.5a7c465edaed19416660fcbcc85cdf7f.svg";
export { ForwardRef as ReactComponent };